import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuthentication, useB3Config, useQueryB3 } from "../../../../../global-account/react/index.js";
import { ecosystemWalletId } from "../../../../../shared/constants/index.js";
import { client } from "../../../../../shared/utils/thirdweb.js";
import { ConnectEmbed, darkTheme, lightTheme } from "thirdweb/react";
import { useMemo } from "react";
import { ecosystemWallet } from "thirdweb/wallets";
export function LoginStepContainer(t0) {
  const $ = _c(7);
  const {
    children,
    partnerId
  } = t0;
  let t1;
  if ($[0] !== partnerId) {
    t1 = {
      query: {
        partnerId,
        $limit: 1
      }
    };
    $[0] = partnerId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: partner
  } = useQueryB3("global-accounts-partners", "find", t1, !!partnerId);
  const partnerLogo = partner?.data?.[0]?.loginCustomization?.logoUrl;
  let t2;
  if ($[2] !== partnerLogo) {
    t2 = partnerLogo && _jsx("img", {
      src: partnerLogo,
      alt: "Partner Logo",
      className: "partner-logo mb-6 h-12 w-auto object-contain"
    });
    $[2] = partnerLogo;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t2) {
    t3 = _jsxs("div", {
      className: "bg-b3-react-background flex flex-col items-center justify-center pt-6",
      children: [t2, children]
    });
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
/** Inner component that only mounts when partnerId is a non-empty string.
 *  Keeps all hooks unconditional without calling useAuthentication(""). */
function LoginStepContent({
  onSuccess,
  chain,
  partnerId,
  theme
}) {
  const wallet = useMemo(() => ecosystemWallet(ecosystemWalletId, {
    partnerId
  }), [partnerId]);
  // skipAutoConnect: AuthenticationProvider already owns the auto-connect instance.
  // Creating another here would cause a second authentication cycle (another 401 attempt)
  // that makes the modal flash between spinner and blank before finally showing the login form.
  const {
    onConnect
  } = useAuthentication(partnerId, {
    skipAutoConnect: true
  });
  return _jsx(LoginStepContainer, {
    partnerId: partnerId,
    children: _jsx(ConnectEmbed, {
      showThirdwebBranding: false,
      autoConnect: false,
      client: client,
      chain: chain,
      wallets: [wallet],
      theme: theme === "light" ? lightTheme({
        colors: {
          modalBg: "hsl(var(--b3-react-background))"
        }
      }) : darkTheme({
        colors: {
          modalBg: "hsl(var(--b3-react-background))"
        }
      }),
      style: {
        width: "100%",
        height: "100%",
        border: 0
      },
      header: {
        title: "Sign in with B3",
        titleIcon: "https://cdn.b3.fun/b3_logo.svg"
      },
      className: "b3-login-step",
      onConnect: async (wallet_0, allConnectedWallets) => {
        await onConnect(wallet_0, allConnectedWallets);
        const account = wallet_0.getAccount();
        if (!account) throw new Error("No account found");
        await onSuccess(account);
      }
    })
  });
}
export function LoginStep(t0) {
  const $ = _c(5);
  const {
    onSuccess,
    chain
  } = t0;
  const {
    partnerId,
    theme
  } = useB3Config();
  if (!partnerId) {
    return null;
  }
  let t1;
  if ($[0] !== chain || $[1] !== onSuccess || $[2] !== partnerId || $[3] !== theme) {
    t1 = _jsx(LoginStepContent, {
      onSuccess,
      chain,
      partnerId,
      theme
    });
    $[0] = chain;
    $[1] = onSuccess;
    $[2] = partnerId;
    $[3] = theme;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}